import { useEffect, useState } from "react";

// Paginates an already-loaded array client-side (every grid in this app
// fetches its full list up front via api.get(...) — there's no server-side
// paging in api.js/Supabase queries to hook into). Resets to page 1 whenever
// the item count changes (a filter being applied/cleared, a row being
// added/removed) so the user never lands on a now-empty trailing page.
export default function usePagination(items, pageSize = 20) {
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
  }, [items.length]);

  const pageCount = Math.max(1, Math.ceil(items.length / pageSize));
  const safePage = Math.min(page, pageCount);
  const pageItems = items.slice((safePage - 1) * pageSize, safePage * pageSize);

  return {
    page: safePage,
    setPage,
    pageCount,
    pageItems,
    totalItems: items.length,
    pageSize,
  };
}
